import { createCrudSlice } from "./createCrudSlice";
import {
  ADD_DYNAMIC_PRICES,
  GET_DYNAMIC_PRICES,
} from "helpers/url_helper";

const { reducer, actions, thunks } = createCrudSlice({
  name: "dynamic prices",

  urls: {
    add: ADD_DYNAMIC_PRICES,
    getList: GET_DYNAMIC_PRICES,
  },

  initialFilters: {
    pageNo: 1,
    perPage: 50,
    orderBy: -1,
    status: -1,
    keyword: "",
    planId: "",
    type: "",
    dates: [],
  },

  additionalThunks: {
  },

  initialState: {},
});

// Export actions
export const { setFilter, resetFilters, clearItemDetails } = actions;

// Export thunks
export const {
  getList: getDynamicPrices,
  add: addDynamicPrices,
} = thunks;

// Export reducer
export default reducer;
